import { render, staticRenderFns } from "./personSwiper.vue?vue&type=template&id=5967b508&scoped=true&"
import script from "./personSwiper.vue?vue&type=script&lang=js&"
export * from "./personSwiper.vue?vue&type=script&lang=js&"
import style0 from "./personSwiper.vue?vue&type=style&index=0&id=5967b508&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5967b508",
  null
  
)

export default component.exports